import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCogs, FaUserShield, FaBoxes, FaShieldAlt, FaHandshake, FaLeaf, FaQuestionCircle, FaChevronUp, FaChevronDown, FaCarAlt, FaBuilding, FaCog, } from 'react-icons/fa';
import { BsBank, BsCarFront, BsCarFrontFill, BsPersonBadge, BsShop } from 'react-icons/bs';
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from '../../composant_reutilisable/navbar';
import useAuth from '../../composant_reutilisable/useAuth';
import { useNavigate } from 'react-router-dom';
import { FaHardDrive, FaRoadBarrier } from 'react-icons/fa6';
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Pas_acces from '../../composant_reutilisable/pas_acces';
import axios from 'axios';
import Footer from '../../composant_reutilisable/footer';

const Elementaires = () => {
    useAuth();
    const user_id = localStorage.getItem('userId');
    const navigate = useNavigate();

    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        if (user_id) {

        }
    }, [user_id]);

    const menuItems = [
        //{ icon: <BsCarFrontFill />, text: 'Genre de Véhicules', link: '/Liste-genres-vehicules' },
        { icon: <BsCarFront />, text: 'Type de véhicules', link: '/Liste-types-vehicules' },
        // { icon: <FaShieldAlt />, text: 'Assureur', link: '/Liste-assureurs' },
        // { icon: <BsShop />, text: 'Centres de fret', link: '/Liste-frets' },
        // { icon: <FaHandshake />, text: 'Bailleurs de fret', link: '/Liste-bailleurs' },
        // { icon: <BsPersonBadge />, text: 'Conducteur', link: '/Liste-conducteur' },
        { icon: <FaRoadBarrier />, text: 'Parc', link: '/Liste-parc' },
        // { icon: <FaLeaf />, text: 'Nature du fret', link: '/Liste-nature' },
        // { icon: <FaBuilding />, text: 'Organisations professionnelles', link: '/Liste-organisations' },
        { icon: <FaCog />, text: 'Essieux', link: '/Liste-essieux' },
        { icon: <FaLeaf />, text: 'Catégorie', link: '/Liste-categories' },

    ];

    const handleClick = (lien) => {
        navigate(lien);
    };

    const [showGlossary, setShowGlossary] = useState(false);

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token')
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Elementaires")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaCarAlt size={25} className='mr-2' /> Elémentaires
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-elementaires'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        {/* <Link to={`/elementaires`}>Elementaires</Link> */}
                                        Elémentaires
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight text-center p-5">
                        <div className="row mx-auto justify-content-center">
                            {menuItems.map((item, index) => (
                                <div key={index} className="col-md-2 mb-4">
                                    {/* <div className="card rounded shadow-sm" onClick={() => handleClick(item.link)} style={{ cursor: 'pointer' }}>
                                        <div className="card-body">
                                            <div className="mb-3 icon-small">{item.icon}</div>
                                            <h5><Link className='text-dark' to={item.link}>{item.text}</Link></h5>
                                        </div>
                                    </div> */}
                                    <div className="card rounded shadow-sm h-100 d-flex flex-column justify-content-center align-items-center" onClick={() => handleClick(item.link)} style={{ cursor: 'pointer' }}>
                                        <div className="card-body ">
                                            <div className="mb-3 icon-small">{item.icon}</div>
                                            <h5 >
                                                <Link className="text-dark text-decoration-none" to={item.link}>
                                                    {item.text}
                                                </Link>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="footer text-center">
                        <Footer />
                    </div>

                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Elementaires;
